import { useEffect, useRef } from 'react';
import type { PropsWithChildren } from 'react';

import { useAuth } from '../../hooks/useAuth/useAuth';
import { useIntercom } from '../../hooks/useIntercom/useIntercom';

const IntercomProvider = ({ children }: PropsWithChildren) => {
  const { isLoggedIn } = useAuth();
  const { boot, bootAnonymous, shutdown } = useIntercom();
  const lastIsLoggedInRef = useRef<typeof isLoggedIn>(undefined);

  useEffect(() => {
    if (lastIsLoggedInRef.current === isLoggedIn) return;
    lastIsLoggedInRef.current = isLoggedIn;

    shutdown();

    if (isLoggedIn) {
      void boot();
    } else {
      bootAnonymous();
    }
  }, [isLoggedIn, boot, bootAnonymous, shutdown]);

  return <>{children}</>;
};

export default IntercomProvider;
